import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import PetcoCircularRegular from "../Fonts/PetcoCircularWeb-Regular.woff";
import PetcoCircularRegular2 from "../Fonts/PetcoCircularWeb-Regular.woff2";
import PetcoCircularRegular3 from "../Fonts/PetcoCircularWeb-Thin.woff";

const theme = createTheme({
  palette: {
    primary: {
      light: "#ffffff",
      main: "#00205b",
      dark: "#6edcfa",
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#f39a0c",
      main: "#6edcfa",
      dark: "#fb4341",
      contrastText: "#ffffff",
    },
    error: {
      light: red[500],
      main: red[700],
      dark: red[900],
      contrastText: "#ffffff",
    },
  },

  typography: {
    useNextVariants: true,
    fontFamily:
      '"PetcoCircularRegular" , "PetcoCircularRegular2", "PetcoCircularRegular3" ,"Montserrat"',
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [PetcoCircularRegular],
        "@font-face": [PetcoCircularRegular2],
        "@font-face": [PetcoCircularRegular3],
      },
    },
  },
});

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;
